"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_2 = require("react");
var ThemeSetting;
(function (ThemeSetting) {
    ThemeSetting["LIGHT"] = "LIGHT";
    ThemeSetting["DARK"] = "DARK";
    ThemeSetting["SYSTEM"] = "SYSTEM";
})(ThemeSetting = exports.ThemeSetting || (exports.ThemeSetting = {}));
var DarkThemeKey = 'dark';
var defaultState = {
    isDark: false,
    toggleDark: function () { return undefined; },
    themeSetting: ThemeSetting.SYSTEM,
    changeThemeSetting: function (_) { return undefined; },
    initThemeFromStorage: function () { return undefined; }
};
exports.ThemeManagerContext = react_2.createContext(defaultState);
var systemDarkModeSetting = function () { return window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null; };
var isDarkModeActive = function () {
    var _a;
    // Assume that dark mode is not active if there's no system dark mode setting available
    return !!((_a = systemDarkModeSetting()) === null || _a === void 0 ? void 0 : _a.matches);
};
exports.ThemeManagerProvider = function (props) {
    var _a = react_2.useState(false), isDark = _a[0], setIsDark = _a[1];
    var _b = react_2.useState(ThemeSetting.SYSTEM), themeSetting = _b[0], setThemeSetting = _b[1];
    var toggleDark = function (value) {
        var newIsDark = (value !== null && value !== void 0 ? value : !isDark);
        var theme = newIsDark ? ThemeSetting.DARK : ThemeSetting.LIGHT;
        setIsDark(newIsDark);
        setThemeSetting(theme);
        localStorage.setItem(DarkThemeKey, theme);
    };
    var changeThemeSetting = function (setting) {
        switch (setting) {
            case ThemeSetting.SYSTEM: {
                setIsDark(isDarkModeActive());
                break;
            }
            case ThemeSetting.LIGHT:
            case ThemeSetting.DARK:
                setIsDark(setting === ThemeSetting.DARK);
        }
        setThemeSetting(setting);
        localStorage.setItem(DarkThemeKey, setting);
    };
    var initThemeFromStorage = function () {
        var themeFromLocalStorage = localStorage.getItem(DarkThemeKey);
        if (!themeFromLocalStorage) {
            setIsDark(isDarkModeActive());
            return;
        }
        if (themeFromLocalStorage in ThemeSetting) {
            changeThemeSetting(themeFromLocalStorage);
        }
        else {
            // Fallback if the stored theme is the legacy "true"/"false"
            changeThemeSetting(JSON.parse(themeFromLocalStorage) ? ThemeSetting.DARK : ThemeSetting.LIGHT);
        }
    };
    return (react_1.default.createElement(exports.ThemeManagerContext.Provider, { value: {
            isDark: isDark,
            toggleDark: toggleDark,
            themeSetting: themeSetting,
            changeThemeSetting: changeThemeSetting,
            initThemeFromStorage: initThemeFromStorage
        } }, props.children));
};
